import { render, staticRenderFns } from "./WhyChoose.vue?vue&type=template&id=4db0ea2d&scoped=true&"
import script from "./WhyChoose.vue?vue&type=script&lang=js&"
export * from "./WhyChoose.vue?vue&type=script&lang=js&"
import style0 from "./WhyChoose.vue?vue&type=style&index=0&id=4db0ea2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db0ea2d",
  null
  
)

export default component.exports